export enum ConsentType {
  TERMS_AND_CONDITIONS = 'Terms and Conditions',
  PRIVACY_POLICY = 'Privacy Policy',
  GENERAL_MARKETING = 'General Marketing',
  UBER_PRO_RIDEHAILING = 'Uber Pro Ridehailing',
}
